import React from 'react';

import { ReferralContext } from '~referral/contexts';

function ReferralProvider({ analytics, children }) {
  return (
    <ReferralContext.Provider value={{ analytics }}>
      {children}
    </ReferralContext.Provider>
  );
}

export default ReferralProvider;
